import { fetchCofidocRefunds } from "@/api/billing/fetchCofidocRefunds";
import { useSystemContext } from "@/provider/common/SystemProvider";
import { Refund } from "@/types/nurse";
import { useQueryParams } from "@/utils/useQueryParams";
import React, { useState, useEffect } from "react";

export function RefundViewWrapper({ children }) {
  const { setLoading, getUser, application } = useSystemContext();
  const [refunds, setRefunds] = useState<Refund[]>([]);
  const params = useQueryParams();

  // Get refunds function
  async function getFilteredRefunds() {
    try {
      const user = getUser();
      const email = user?.email || null;
      const username = user?.identifiant || null;

      const refunds = await fetchCofidocRefunds({
        username,
        email,
        application,
      });
      setRefunds(refunds);
      return refunds?.sort((a, b) => a.date.getTime() - b.date.getTime());
    } catch (error) {
      console.log("error :", error);
    } finally {
    }
  }


  // Get data function
  async function getData() {
    try {
      const dateFilter = params.period ? new Date(Number(params.period)) : new Date();
      setLoading(true);

      const refunds = await getFilteredRefunds();
      // Filter refunds for the selected month and for the selected year
      const filteredAndSortedRefunds = refunds?.filter(
        (refund) => refund.date.getUTCMonth() === dateFilter.getMonth() && refund.date.getUTCFullYear() === dateFilter.getFullYear()
      );
      setRefunds(filteredAndSortedRefunds);
    } catch (error) {
      console.log("error :", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.period]);

  // Pluralize function
  const pluralize = (count: number, singular: string, plural: string) => {
    return count === 1 ? singular : plural;
  };

  return (
    <>
      {React.cloneElement(children, {
        pluralize,
        refunds,
      })}
    </>
  );
}
